import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseRegressContactProps {
  contactId?: string
  onSuccess: () => void
  onError: () => void
}

const useRegressContact = ({ contactId, onSuccess, onError }: UseRegressContactProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['regressContact'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/contacts/${contactId}/regress`)
    },
    onSuccess,
    onError,
  });
}

export default useRegressContact